export default __webpack_public_path__ + "static/media/home4.6ac10167.jpg";